<template>
    <div>
        <el-card>
            <el-row :gutter="20">
                <el-col :span="8">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <!--<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>-->
                        <el-breadcrumb-item>ADRESS LIST</el-breadcrumb-item>
                    </el-breadcrumb>
                </el-col>
                <el-col :span="16" style="text-align: right">
                    <el-button type="primary" @click="showAdd()" style="float: right;">Add ADRESS</el-button>
                </el-col>
            </el-row>
        </el-card>

        <el-table

                border=""
                :data="tasklist"
                style="width: 100%"
        >
            <el-table-column
                    width="200px"
                    prop="solution"
                    label="Solution">
            </el-table-column>
            <el-table-column
                    prop="adress"
                    label="adress">
            </el-table-column>


            <el-table-column
                    width="100px"
                    label="Options">
                <template slot-scope="scope">
                    <el-row :gutter="20">
                        <el-col :span="4">
                            <i class="el-icon-delete" title="Delete" @click="deleteit(scope.row.id)"></i>
                        </el-col>
                        <el-col :span="4">
                            <i class="el-icon-edit" title="Edit" @click="editShow(scope.row.id)"></i>
                        </el-col>
                    </el-row>
                </template>

            </el-table-column>
        </el-table>

        <el-dialog
                title="编辑"
                :visible.sync="editVisible" @click="addClose">
            <el-form :model="editForm" :rules="rules" ref="editFormRef">

                <el-form-item prop="id" label="id" hidden>
                    <el-input v-if="iseidt==='yes'" v-model="editForm.id" ></el-input>
                </el-form-item>
                <el-form-item prop="solution" label="solution">
                    <el-select  v-model="editForm.solution" placeholder="please choose" >
                        <el-option
                                v-for="item in setForm.rma_solution"
                                :label="item"
                                :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item prop="adress" label="adress">
                    <el-input v-model="editForm.adress" type="textarea" ></el-input>
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">Cancel</el-button>
                <el-button type="primary" @click="edit">Submit</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "UserList.vue",

        data(){
            return{
                queryInfo:{
                    query:"",
                    page:1,
                    pagesize:10,
                },
                total:0,
                tasklist:[],
                addVisible:false,
                editVisible:false,
                iseidt:"",
                setForm:{},
                addForm:{},
                editForm:{},
                temp:"",
                role:"",
                depss:{},
                rules:{

                },

            }

        },

        created() {
            document.title = "ADRESS LIST - Welcome to Sunwave’s RMA Process System";
            this.setForm =  JSON.parse(localStorage.getItem('setform'));
            this.getTaskList();
        },
        methods:{

            async getTaskList(){
                const result=await this.$http.get("adress/list");
                if(result.data.error_code!==0){
                    this.$message.error(result.data.msg);
                }else {
                    this.tasklist=result.data.data;

                }
                this.role=localStorage.getItem("role");
            },


            addClose(){
                this.$refs.addFormRef.resetFields();
                this.editVisible=false;
            },


            async getDate(id){
                const result=await this.$http.get("adress/info/"+id);
                this.editForm=result.data.data;
            }
            ,
            showAdd(){
                this.editVisible=true;
                this.editForm={};
                this.iseidt="no";
            },
            async editShow(id){
                    const result=await this.$http.get("adress/info/"+id);
                    this.editForm=result.data.data;
                    this.iseidt="yes";
                this.editVisible=true;

            },

            edit() {
                this.$refs.editFormRef.validate(async valid => {
                    if (!valid) {
                        console.log('error submit!!');
                        return false;
                    }
                    var result={};
                    if(this.iseidt==="yes"){
                         result=await this.$http.post("adress/edit",this.editForm);
                    }else {
                         result=await this.$http.post("adress/add",this.editForm);
                    }

                    if (result.data.error_code!==0){
                        this.$message.error(result.data.msg);
                    }else {
                        this.$message.success(result.data.msg);
                        this.editVisible=false;
                        this.getTaskList();
                    }
                });
            },

            async deleteit(id){
                console.log(id);
                const result=await this.$http.get("adress/del/"+id);
                console.log(result);
                if (result.data.error_code!==0){
                    this.$message.error(result.data.msg);
                }else {
                    this.$message.success(result.data.msg);
                    this.getTaskList();
                }
            },


        }
    }
</script>

<style lang="less" scoped>
    .el-table{

    }
    .el-breadcrumb{
        padding-top: 10px;
    }
    .el-card{
        margin-bottom: 5px;
    }
    .el-table{
        margin-bottom: 5px;
    }
    .el-table-column{
        padding-left: 10px;
    }
    .el-form{
        width: 100%;
    }
</style>
